"use client"

import TablaRrhhReportesComponent from "./TablaRrhhReportesComponent.js"

const RrhhReportesComponent = () => {
  return <TablaRrhhReportesComponent />
}

export default RrhhReportesComponent
